// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sidebar {
    min-width: 150px;
    width: var(--w-sidebar);
    height: calc(var(--vh, 1vh) * 100);

    display: flex;
    flex-direction: column;

    position: fixed;
    top: 0;
    left: 0;

    background: var(--cl-surface);
    border-right: 1px solid var(--cl-border);
    z-index: 1000;

    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
}

/* Header inside sidebar */
.sidebarHeader {
    padding: 16px 18px 10px 18px;
}

.sidebarHeaderActions,
.topbarActions {
    display: flex;
    gap: 8px;
    align-items: center;
}

.sidebarHeaderActions {
    margin-top: 12px;
    flex-wrap: wrap;
}

.sidebarHeader hr {
    border: none;
    height: 1px;
    background: var(--cl-shadow);
    margin-top: 12px;
}

.themeBtn {
    width: 100%;
    border: 1px solid var(--cl-border);
    background: var(--cl-surface-2);
    color: var(--cl-dark);
    border-radius: 10px;
    padding: 8px 10px;
    cursor: pointer;
    min-height: 44px;
    white-space: nowrap;
}

.sidebarTopbar .themeBtn {
    width: auto;
    min-width: 44px;
    padding: 8px 10px;
    flex-shrink: 0;
}

/* Items wrapper */
.sidebarItems {
    display: flex;
    flex-direction: column;
    padding: 8px 0 14px 0;
}

/* Link styles */
.sidebarLink {
    display: block;
    padding: 10px 18px;
    margin: 2px 10px;
    border-radius: 12px;
    color: var(--cl-dark);
    line-height: 1.35;
    white-space: normal;
    word-break: break-word;
}

.sidebarLink:hover {
    background: rgba(64, 150, 255, 0.12);
}

.sidebarLinkActive {
    font-weight: 800;
    background: rgba(64, 150, 255, 0.12);
}

body[data-theme="dark"] #sidebar {
    background: #111b28;
    border-right-color: #344357;
    box-shadow: 10px 0 30px rgba(4, 10, 18, 0.18);
}

body[data-theme="dark"] .sidebarHeader hr {
    background: rgba(230, 237, 247, 0.12);
}

body[data-theme="dark"] .themeBtn,
body[data-theme="dark"] .burgerBtn {
    background: #1b2a3b;
    border-color: #3a4b62;
    color: #eff6ff;
}

body[data-theme="dark"] .sidebarLink {
    color: #eff6ff;
}

body[data-theme="dark"] .sidebarLink:hover {
    background: rgba(127, 179, 255, 0.18);
}

body[data-theme="dark"] .sidebarLinkActive {
    background: rgba(127, 179, 255, 0.26);
    color: #ffffff;
}

/* Mobile topbar + burger */
.sidebarTopbar {
    display: none;
}

/* Overlay for mobile */
.sidebarOverlay {
    display: none;
}

/* ===== Mobile ===== */
@media (max-width: 768px) {
    .sidebarTopbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;

        position: sticky;
        top: 0;
        z-index: 900;

        min-height: 56px;
        padding: 0 12px;
        padding-top: env(safe-area-inset-top);

        background: #fff;
        background: var(--cl-surface);
        border-bottom: 1px solid var(--cl-border);
    }

    body[data-theme="dark"] .sidebarTopbar {
        background: #111b28;
        border-bottom-color: #344357;
        box-shadow: 0 12px 30px rgba(4, 10, 18, 0.2);
    }

    .burgerBtn {
        appearance: none;
        border: 1px solid var(--cl-border);
        background: var(--cl-surface);
        border-radius: 12px;
        padding: 10px 12px;
        cursor: pointer;
        min-height: 44px;
        min-width: 44px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .burgerLines {
        width: 18px;
        height: 12px;
        position: relative;
        display: block;
    }

    .burgerLines::before,
    .burgerLines::after,
    .burgerLines span {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        height: 2px;
        background: var(--cl-dark);
        border-radius: 2px;
    }

    .burgerLines::before { top: 0; }
    .burgerLines span { top: 5px; }
    .burgerLines::after { bottom: 0; }

    body[data-theme="dark"] .burgerLines::before,
    body[data-theme="dark"] .burgerLines::after,
    body[data-theme="dark"] .burgerLines span {
        background: #eff6ff;
    }

    .topbarTitle {
        display: flex;
        flex-direction: column;
        line-height: 1.1;
        min-width: 0;
        flex: 1 1 auto;
    }

    .topbarTitle strong {
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .topbarTitle small {
        font-size: 12px;
        opacity: 0.7;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .topbarActions {
        margin-left: auto;
        flex-shrink: 0;
    }

    /* sidebar becomes drawer */
    #sidebar {
        width: min(86vw, 320px);
        max-width: calc(100vw - 16px);
        min-width: min(260px, calc(100vw - 16px));
        padding-top: max(12px, env(safe-area-inset-top));
        padding-bottom: max(12px, env(safe-area-inset-bottom));

        transform: translateX(-110%);
        transition: transform 200ms ease;
        box-shadow: 0 18px 40px rgba(0,0,0,0.25);
        border-right: none;
    }

    #sidebar[data-open="true"] {
        transform: translateX(0);
    }

    .sidebarOverlay {
        display: block;
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.35);
        z-index: 999;
    }

    body[data-theme="dark"] .sidebarOverlay {
        background: rgba(0,0,0,0.5);
    }
}

@media (max-width: 420px) {
    .sidebarTopbar {
        gap: 8px;
        padding-left: 10px;
        padding-right: 10px;
    }

    .sidebarTopbar .themeBtn {
        padding-left: 8px;
        padding-right: 8px;
    }

    .sidebarLink {
        padding: 12px 16px;
        margin-left: 8px;
        margin-right: 8px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,kCAAkC;;IAElC,aAAa;IACb,sBAAsB;;IAEtB,eAAe;IACf,MAAM;IACN,OAAO;;IAEP,6BAA6B;IAC7B,wCAAwC;IACxC,aAAa;;IAEb,gBAAgB;IAChB,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA,0BAA0B;AAC1B;IACI,4BAA4B;AAChC;;AAEA;;IAEI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,+BAA+B;IAC/B,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA,gBAAgB;AAChB;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;IAEI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;AACjB;;AAEA,uBAAuB;AACvB;IACI,aAAa;AACjB;;AAEA,uBAAuB;AACvB;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,SAAS;;QAET,gBAAgB;QAChB,MAAM;QACN,YAAY;;QAEZ,gBAAgB;QAChB,eAAe;QACf,qCAAqC;;QAErC,gBAAgB;QAChB,6BAA6B;QAC7B,yCAAyC;IAC7C;;IAEA;QACI,mBAAmB;QACnB,4BAA4B;QAC5B,4CAA4C;IAChD;;IAEA;QACI,gBAAgB;QAChB,kCAAkC;QAClC,6BAA6B;QAC7B,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,cAAc;IAClB;;IAEA;;;QAGI,WAAW;QACX,kBAAkB;QAClB,OAAO;QACP,QAAQ;QACR,WAAW;QACX,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA,uBAAuB,MAAM,EAAE;IAC/B,oBAAoB,QAAQ,EAAE;IAC9B,sBAAsB,SAAS,EAAE;;IAEjC;;;QAGI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,cAAc;IAClB;;IAEA,2BAA2B;IAC3B;QACI,uBAAuB;QACvB,6BAA6B;QAC7B,yCAAyC;QACzC,gDAAgD;QAChD,sDAAsD;;QAEtD,4BAA4B;QAC5B,gCAAgC;QAChC,wCAAwC;QACxC,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,cAAc;QACd,eAAe;QACf,QAAQ;QACR,4BAA4B;QAC5B,YAAY;IAChB;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;IACrB;AACJ","sourcesContent":["#sidebar {\n    min-width: 150px;\n    width: var(--w-sidebar);\n    height: calc(var(--vh, 1vh) * 100);\n\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n\r\n    background: var(--cl-surface);\n    border-right: 1px solid var(--cl-border);\n    z-index: 1000;\r\n\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n}\n\n/* Header inside sidebar */\n.sidebarHeader {\n    padding: 16px 18px 10px 18px;\n}\n\n.sidebarHeaderActions,\n.topbarActions {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.sidebarHeaderActions {\n    margin-top: 12px;\n    flex-wrap: wrap;\n}\n\n.sidebarHeader hr {\n    border: none;\n    height: 1px;\n    background: var(--cl-shadow);\r\n    margin-top: 12px;\r\n}\n\n.themeBtn {\n    width: 100%;\n    border: 1px solid var(--cl-border);\n    background: var(--cl-surface-2);\n    color: var(--cl-dark);\n    border-radius: 10px;\n    padding: 8px 10px;\n    cursor: pointer;\n    min-height: 44px;\n    white-space: nowrap;\n}\n\n.sidebarTopbar .themeBtn {\n    width: auto;\n    min-width: 44px;\n    padding: 8px 10px;\n    flex-shrink: 0;\n}\n\n/* Items wrapper */\n.sidebarItems {\n    display: flex;\n    flex-direction: column;\r\n    padding: 8px 0 14px 0;\r\n}\r\n\r\n/* Link styles */\r\n.sidebarLink {\r\n    display: block;\r\n    padding: 10px 18px;\r\n    margin: 2px 10px;\n    border-radius: 12px;\n    color: var(--cl-dark);\n    line-height: 1.35;\n    white-space: normal;\n    word-break: break-word;\n}\n\n.sidebarLink:hover {\n    background: rgba(64, 150, 255, 0.12);\n}\n\r\n.sidebarLinkActive {\n    font-weight: 800;\n    background: rgba(64, 150, 255, 0.12);\n}\n\nbody[data-theme=\"dark\"] #sidebar {\n    background: #111b28;\n    border-right-color: #344357;\n    box-shadow: 10px 0 30px rgba(4, 10, 18, 0.18);\n}\n\nbody[data-theme=\"dark\"] .sidebarHeader hr {\n    background: rgba(230, 237, 247, 0.12);\n}\n\nbody[data-theme=\"dark\"] .themeBtn,\nbody[data-theme=\"dark\"] .burgerBtn {\n    background: #1b2a3b;\n    border-color: #3a4b62;\n    color: #eff6ff;\n}\n\nbody[data-theme=\"dark\"] .sidebarLink {\n    color: #eff6ff;\n}\n\nbody[data-theme=\"dark\"] .sidebarLink:hover {\n    background: rgba(127, 179, 255, 0.18);\n}\n\nbody[data-theme=\"dark\"] .sidebarLinkActive {\n    background: rgba(127, 179, 255, 0.26);\n    color: #ffffff;\n}\n\r\n/* Mobile topbar + burger */\r\n.sidebarTopbar {\r\n    display: none;\r\n}\r\n\r\n/* Overlay for mobile */\r\n.sidebarOverlay {\r\n    display: none;\r\n}\r\n\r\n/* ===== Mobile ===== */\r\n@media (max-width: 768px) {\r\n    .sidebarTopbar {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 12px;\n\r\n        position: sticky;\r\n        top: 0;\r\n        z-index: 900;\n\n        min-height: 56px;\n        padding: 0 12px;\n        padding-top: env(safe-area-inset-top);\n\n        background: #fff;\n        background: var(--cl-surface);\n        border-bottom: 1px solid var(--cl-border);\n    }\n\n    body[data-theme=\"dark\"] .sidebarTopbar {\n        background: #111b28;\n        border-bottom-color: #344357;\n        box-shadow: 0 12px 30px rgba(4, 10, 18, 0.2);\n    }\n\r\n    .burgerBtn {\r\n        appearance: none;\r\n        border: 1px solid var(--cl-border);\n        background: var(--cl-surface);\n        border-radius: 12px;\r\n        padding: 10px 12px;\r\n        cursor: pointer;\r\n        min-height: 44px;\r\n        min-width: 44px;\r\n        display: inline-flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .burgerLines {\r\n        width: 18px;\r\n        height: 12px;\r\n        position: relative;\r\n        display: block;\r\n    }\r\n\r\n    .burgerLines::before,\r\n    .burgerLines::after,\r\n    .burgerLines span {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 0;\r\n        right: 0;\r\n        height: 2px;\r\n        background: var(--cl-dark);\r\n        border-radius: 2px;\r\n    }\r\n\r\n    .burgerLines::before { top: 0; }\n    .burgerLines span { top: 5px; }\n    .burgerLines::after { bottom: 0; }\n\n    body[data-theme=\"dark\"] .burgerLines::before,\n    body[data-theme=\"dark\"] .burgerLines::after,\n    body[data-theme=\"dark\"] .burgerLines span {\n        background: #eff6ff;\n    }\n\r\n    .topbarTitle {\n        display: flex;\n        flex-direction: column;\n        line-height: 1.1;\n        min-width: 0;\n        flex: 1 1 auto;\n    }\n\n    .topbarTitle strong {\n        font-size: 14px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .topbarTitle small {\n        font-size: 12px;\n        opacity: 0.7;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .topbarActions {\n        margin-left: auto;\n        flex-shrink: 0;\n    }\n\n    /* sidebar becomes drawer */\n    #sidebar {\n        width: min(86vw, 320px);\n        max-width: calc(100vw - 16px);\n        min-width: min(260px, calc(100vw - 16px));\n        padding-top: max(12px, env(safe-area-inset-top));\n        padding-bottom: max(12px, env(safe-area-inset-bottom));\n\n        transform: translateX(-110%);\n        transition: transform 200ms ease;\n        box-shadow: 0 18px 40px rgba(0,0,0,0.25);\n        border-right: none;\n    }\n\r\n    #sidebar[data-open=\"true\"] {\r\n        transform: translateX(0);\r\n    }\r\n\r\n    .sidebarOverlay {\n        display: block;\n        position: fixed;\n        inset: 0;\n        background: rgba(0,0,0,0.35);\n        z-index: 999;\n    }\n\n    body[data-theme=\"dark\"] .sidebarOverlay {\n        background: rgba(0,0,0,0.5);\n    }\n}\n\n@media (max-width: 420px) {\n    .sidebarTopbar {\n        gap: 8px;\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n\n    .sidebarTopbar .themeBtn {\n        padding-left: 8px;\n        padding-right: 8px;\n    }\n\n    .sidebarLink {\n        padding: 12px 16px;\n        margin-left: 8px;\n        margin-right: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
